import React, { useEffect, useState } from "react";
import "./Home.scss";
import Store from "../../components/Store/Store";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

import { useAuthValidation } from "../../../hooks/useAuthValidation"; // Hook que consome o contexto
import api from "../../../services/api"; // Instância do Axios configurado
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function Home() {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation(); // Obtém dados do contexto
  const [challenges, setChallenges] = useState([]);
  const type = localStorage.getItem("typeUser");

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    if (!loading && user) {
      // Busca desafios apenas uma vez
      api
        .get("/challenges")
        .then((response) => {
          setChallenges(response.data);
        })
        .catch((error) => {
          console.error("Erro ao buscar desafios:", error);
        });
    }
  }, [loading, user]);

  if (loading) {
    return <div className="loading">{t("loading")}</div>; // Exibe um spinner enquanto carrega
  }

  return (
    <DefaultLayout>
      <section className="home">
        <div className="container">
          <div className="challenges">
            <Swiper spaceBetween={50} slidesPerView={1} navigation modules={[Navigation, Pagination]}>
              {challenges.map((challenge, index) => (
                <SwiperSlide className="card-swiper" key={index}>
                  <img src={challenge.image.link} alt="Desafios" className="Desafios" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <Store />
        </div>
      </section>
    </DefaultLayout>
  );
}

export default Home;
